import React, { useEffect, useContext, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { InjectedIntlProps } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
// import { Label, ILabelStyles } from '@fluentui/react/lib/Label';
// import { PivotItem } from '@fluentui/react/lib/Pivot';
// import { IStyleSet } from '@fluentui/react/lib/Styling';
// import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
// import { Stack, IStackTokens, IStackStyles } from '@fluentui/react/lib/Stack';
import { Text } from '@fluentui/react/lib/Text';
// import { DefaultButton } from '@fluentui/react';
import { ApplicationContext } from '@msx/platform-services'
import { messages } from './Settings.messages';
import { ExtensionEventTypes } from '@msx/platform-services';
import {
  getCurrentTheme,
  setCurrentTheme,
  // getCurrentLocale,
  // setCurrentLocale,
} from '../../../core/store';

import { getThemeByName } from '../../../core/utils'
import { Field } from '@fluentui/react-components';
import { Book48Filled, Book48Regular } from '@fluentui/react-icons';
import useCustomLogService from '../../services/useCustomLogService';

interface OwnProps {
  onDismissPanel: () => void;
}

type Props = OwnProps & InjectedIntlProps & RouteComponentProps;

const SettingsComponent: (React.FC<Props>) = (props) => {
  const { intl } = props;
  const currentTheme = useSelector(getCurrentTheme);
  // const currentLocale = useSelector(getCurrentLocale);
  const { appState } = useContext(ApplicationContext);
  // const [selectedLanguageItem, setSelectedLanguageItem] = React.useState<IDropdownOption>();
  const [selectedThemeName, setSelectedThemeName] = React.useState<string>(currentTheme.name);
  const reduxDispatch = useDispatch();
  // const stackTokens = { childrenGap: 20 };
  // const stackStyles: Partial<IStackStyles> = { root: { marginTop: 20 } };

  const { trackCustomEvents } = useCustomLogService();

  useEffect(() => {
    // Placeholder
    // eslint-disable-next-line
    trackCustomEvents(`ECIFWorkscopePortal.Settings`,  `Settings pannel opened`, 'Success');
    return () => {
      trackCustomEvents(`ECIFWorkscopePortal.Settings`,  `Settings pannel closed`, 'Success');
    }
  }, []);
  

  //If in future we have to add language settings, we can use it from here
  // const getDisplayLocales = () => {
  //   let result = [];
  //   if (!appState.appConfig.languageConfig.active) {
  //     return result;
  //   }
  //   const locales = appState.appConfig.languageConfig.locales;
  //   Object.keys(locales).forEach(function (key, idx) {
  //     result.push(
  //       {
  //         key: key,
  //         text: locales[key]
  //       });
  //   });
  //   return result;
  // }

  // const languageItems = getDisplayLocales();

  // const handleLanguageChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
  //   setSelectedLanguageItem(item);
  //   localStorage.setItem('locale', item.key as string);

  // };

  const handleThemeChange = useCallback((
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: { key: string }
  ): void => {
    if (!option) return;
    setSelectedThemeName(option.key);
    const newTheme = getThemeByName(option.key);
    reduxDispatch(setCurrentTheme(newTheme));
    localStorage.setItem('theme', option.key);
    document.body.style.background = newTheme.palette.white;
    if (appState.appConfig.enableUserSettingsApi) {
      const newEvent = new CustomEvent(ExtensionEventTypes.THEME_CHANGED, { detail: { theme: newTheme } });
      window.dispatchEvent(newEvent);
    }
    trackCustomEvents(`ECIFWorkscopePortal.Settings.Theme`,  `${option?.key} Theme Selected`, 'Success');
  }, [appState.appConfig, reduxDispatch, trackCustomEvents, setSelectedThemeName, getThemeByName]);

  //If in future we have to add language settings, we can use it from here
  // const handleApplyButonClick = () => {
  //   if (appState.appConfig.enableUserSettingsApi) {
  //     const newEvent = new CustomEvent(ExtensionEventTypes.LOCALE_CHANGED, { detail: { locale: selectedLanguageItem.key } });
  //     window.dispatchEvent(newEvent);
  //   }
  //   reduxDispatch(setCurrentLocale(selectedLanguageItem.key));
  // }

  // const handleDiscardButtonClick = () => {
  //   setSelectedLanguageItem(undefined);
  // }


  const renderThemeSection = useCallback(() => {
    if (!appState.appConfig.themeConfig.active) {
      return null;
    }

    const options = [
      { key: 'default', text: intl.formatMessage(messages.themeLightText), iconName: 'ReadingMode' },
      { key: 'dark', text: intl.formatMessage(messages.themeDarkText), iconName: 'ReadingModeSolid' },
    ];

    return (
      <div style={{ marginTop: '20px' }}>
        <Field label={intl.formatMessage(messages.themeSelectionTile)}>
          <div
            style={{ marginTop: '10px', display: 'flex', gap: '20px' }}
          >
            {options.map(option => (
              <div
                key={option.key}
                onClick={() => handleThemeChange(null, { key: option.key })}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleThemeChange(null, { key: option.key }); } }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: selectedThemeName === option.key ? '2px solid #0078D4' : '1px solid #ccc',
                  borderRadius: '4px',
                  padding: '10px',
                  width: '120px',
                  height: '120px',
                  cursor: 'pointer',
                  backgroundColor: selectedThemeName === 'dark' ? 'rgb(49, 48, 47)' : 'rgb(243, 242, 241)',
                }}
                role="radio"
                aria-checked={selectedThemeName === option.key}
                tabIndex={0}
                onFocus={(e) => e.currentTarget.style.border = '2px solid black'}
                onBlur={(e) => e.currentTarget.style.border = selectedThemeName === option.key ? '2px solid #0078D4' : '1px solid #ccc'}
              >
                {option.key === 'default' ? <Book48Regular /> : <Book48Filled />}
                <Text variant="medium" style={{ marginTop: '10px' }}>{option.text}</Text>
                <input
                  type="radio"
                  value={option.key}
                  checked={selectedThemeName === option.key}
                  onChange={(e) => handleThemeChange(null, { key: e.target.value })}
                  style={{
                    marginTop: '10px',
                    accentColor: selectedThemeName === option.key ? '#0078D4' : 'initial',
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleThemeChange(null, { key: option.key });
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </Field>
      </div>
    );
  }, [appState.appConfig, intl, selectedThemeName, handleThemeChange]);

  //If in future we have to add language settings, we can use it from here
  // const renderGeneralTab = () => {
  //   // you can have multiple section within general tab
  //   return (
  //     <>
  //       {renderThemeSection()}
  //     </>
  //   );
  // }

  // const renderLanguageTab = () => {
  //   if (!appState.appConfig.languageConfig.active) {
  //     return null;
  //   }
  //   const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { marginTop: 5 } };
  //   const labelTitleStyles: Partial<IStyleSet<ILabelStyles>> = {
  //     root: { padding: 0 },
  //   };

  //   const stackButtonsTokens: IStackTokens = { childrenGap: 10 };
  //   const shouldDisableSave = (selectedLanguageItem && currentLocale !== selectedLanguageItem.key) ? false : true;
  //   return (
  //     <PivotItem headerText={intl.formatMessage(messages.languageTabTile)}>
  //       <Stack tokens={stackTokens} styles={stackStyles}>
  //         <Stack >
  //           <Label styles={labelTitleStyles}>{intl.formatMessage(messages.languageSelectionTile)}</Label>
  //           <Text variant="smallPlus">{intl.formatMessage(messages.languageSelectionSubTile)}</Text>
  //           <Dropdown
  //             selectedKey={selectedLanguageItem ? selectedLanguageItem.key : currentLocale}
  //             // eslint-disable-next-line react/jsx-no-bind
  //             onChange={handleLanguageChange}
  //             options={languageItems}
  //             styles={dropdownStyles}
  //           />
  //         </Stack>
  //         <Stack>
  //           <Stack horizontal tokens={stackButtonsTokens}>
  //             <DefaultButton text={intl.formatMessage(messages.applyButtonText)} onClick={handleApplyButonClick} disabled={shouldDisableSave}/>
  //             <DefaultButton text={intl.formatMessage(messages.discardButtonText)} onClick={handleDiscardButtonClick} disabled={shouldDisableSave} />
  //           </Stack>
  //         </Stack>
  //       </Stack>
  //     </PivotItem>
  //   );
  // }

  const renderMain = (): JSX.Element => {
    return (
      <>
        {renderThemeSection()}
      </>
    );
  }

  return renderMain();

}
export const Settings = withRouter(injectIntl(SettingsComponent));


